module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_5012.7540cec1.png";